<template>
  <a class="card-footer-item" @click.prevent="doSomething">
    <b-icon icon="autorenew" custom-size="default"/>
    <span>Load more</span>
  </a>
</template>

<script>
  export default {
    name: "CardLoadMoreSample",
    methods: {
      doSomething() {
        this.$toast.open({
          message: 'Some action happened',
          type: 'is-danger'
        })
      }
    }
  }
</script>

<style scoped>

</style>